import { usePreAnalises } from '@/api/queries/empresa';
import { Skeleton } from '@/components/ui/skeleton';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export function TabPreAnalise({ empresaId }: { empresaId: string }) {
  const { data, isLoading } = usePreAnalises(empresaId);
  if (isLoading) return <Skeleton className="h-96 mt-4" />;
  if (!data || data.length === 0) {
    return <p className="text-muted-foreground mt-4">Sem pré-análise ainda.</p>;
  }

  const latest = data[0];
  if (!latest) return <p className="text-muted-foreground mt-4">Sem pré-análise ainda.</p>;
  const olderVersions = data.slice(1);

  return (
    <div className="space-y-6 mt-4">
      <Card className="p-6">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-medium">
            v{latest.versao_n} · {latest.data_analise}
          </h3>
          <Badge variant="outline">{latest.autor}</Badge>
        </div>
        {latest.resumo_uma_linha && (
          <p className="italic mb-4 text-muted-foreground">{latest.resumo_uma_linha}</p>
        )}

        <h4 className="font-medium mt-4 mb-2">3 Pontos Fortes</h4>
        <ol className="list-decimal pl-6 space-y-1 text-sm">
          {latest.pontos_fortes.map((p, i) => (
            <li key={i}>
              <span className="font-medium">{p.titulo}</span> — {p.evidencia}
            </li>
          ))}
        </ol>

        <h4 className="font-medium mt-4 mb-2">3 Oportunidades</h4>
        <ol className="list-decimal pl-6 space-y-1 text-sm">
          {latest.oportunidades.map((o, i) => (
            <li key={i}>
              <span className="font-medium">{o.titulo}</span> — {o.evidencia}
              {o.impacto_estimado_brl_mes ? (
                <span className="text-muted-foreground">
                  {' '}
                  · impacto ~R$ {o.impacto_estimado_brl_mes}/mês
                </span>
              ) : null}
            </li>
          ))}
        </ol>

        {latest.benchmark_regional && (
          <>
            <h4 className="font-medium mt-4 mb-2">Benchmark</h4>
            <p className="text-sm">{latest.benchmark_regional}</p>
          </>
        )}
        {latest.recomendacao && (
          <>
            <h4 className="font-medium mt-4 mb-2">Recomendação</h4>
            <p className="text-sm">{latest.recomendacao}</p>
          </>
        )}
        {latest.gancho_principal && (
          <p className="mt-4 text-sm">
            <span className="font-medium">Gancho:</span> {latest.gancho_principal}
          </p>
        )}
      </Card>

      {olderVersions.length > 0 && (
        <div>
          <h4 className="font-medium mb-2">Versões anteriores</h4>
          <ul className="text-sm space-y-1">
            {olderVersions.map((v) => (
              <li key={v.id} className="text-muted-foreground">
                v{v.versao_n} · {v.data_analise} · {v.autor}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
